<template>
  <div id="register" class="register">
    <div class="wrapper">
      <div class="content">
        <div class="header">
          <div class="image"></div>
          <div class="tip">找回密码</div>
        </div>
        <div class="input-box">
          <span>新密码</span>
          <input placeholder="最少6个字符" type="password" v-model="password" maxlength="18" />
        </div>
        <div class="input-box">
          <span>确认密码</span>
          <input placeholder="请再次输入新密码" type="password" v-model="password2" maxlength="18" />
        </div>
        <button class="nextbtn" :style="{backgroundColor:activeColor}" @click="nextClick">完成</button>
      </div>
    </div>
  </div>
</template>

<script>
// 引入
import { Toast } from 'mint-ui'

export default {
  data () {
    return {
      password: '',
      password2: '',
      activeColor: ''
    }
  },
  methods: {
    checkParam: function () {
      let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/
      let res = reg.test(this.password)
      if (this.password.length < 6) {
        Toast('请至少输入6位密码')
        return false
      }
      // if (!res) {
      //   Toast('密码至少包含大写字母，小写字母，数字')
      //   return false
      // }
      if (this.utils.isNull(this.password)) {
        Toast('请输入密码！')
        return false
      }
      if (this.password !== this.password2) {
        Toast('新密码与确认密码要保持一致！')
        return false
      }
      return true
    },
    nextClick: function () {
      if (this.checkParam() === false) {
        return
      }
      var _this = this
      let param = {
        phone: this.$route.query.phone,
        password: this.password,
        new_password1: this.password,
        new_password2: this.password2
      }
      this.utils.POST(this.accountUrl + '/account/retrieve', param, function (response) {
        if (parseInt(response.code) === 0) {
          Toast('修改密码成功!')
          _this.$router.go(-2)
        }
      })
    }
  },
  watch: {
    isActive: function (val) {
      this.activeColor = '#fecdcd'
      if (val === true) {
        this.activeColor = '#c41335'
      }
    }
  },
  computed: {
    isActive: function () {
      if (!this.utils.isNull(this.password) && !this.utils.isNull(this.password2)) {
        return true
      }
      return false
    }
  },
  components: { // 注册组件
  },
  mounted () {
  }
}
</script>

<style scoped>
.wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
}
.wrapper .content {
  position: absolute;
  top: 18px;
  left: 15px;
  right: 15px;
  width: calc(100% - 30px);
  height: 250px;
  background-color: #ffffff;
}
.wrapper .content .header {
  position: absolute;
  top: 17px;
  left: 20px;
  right: 20px;
  height: 20px;
}
.wrapper .content .header .image {
  position: absolute;
  top: 4px;
  left: 0px;
  width: 12.5px;
  height: 11px;
  background-image: url("../assets/icon-arrow-red.png");
  background-size: cover;
  background-position: center;
}
.wrapper .content .header .tip {
  position: absolute;
  top: 3px;
  left: 22px;
  height: 14px;
  line-height: 14px;
  font-size: 17px;
  font-weight: bold;
  color: #000000;
}
.content .input-box {
  position: relative;
  top: 55px;
  left: 20px;
  width: calc(100% - 40px);
  height: 54px;
  line-height: 54px;
  border-bottom: solid #eeeeee 1px;
  box-sizing: border-box;
}
.content .input-box span {
  position: absolute;
  font-size: 15px;
  color: #000000;
  top: 20px;
  height: 15px;
  line-height: 15px;
}
.content .input-box input {
  position: absolute;
  left: 70px;
  height: 53px;
  width: calc(100% - 70px);
  line-height: 53px;
  font-size: 15px;
  color: #000000;
  border: none;
  padding: 15px 0;
  line-height: 24px;
  /*background-color: pink;*/
}
.content .input-box input.code {
  width: calc(100% - 170px);
}
.content .input-box .button {
  position: absolute;
  top: 11px;
  right: 0px;
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background-color: #fecdcd;
  border-radius: 15px;
  color: #ffffff;
  font-size: 12px;
}
.content .nextbtn {
  position: relative;
  top: 75px;
  left: 20px;
  width: calc(100% - 40px);
  height: 40px;
  line-height: 40px;
  background-color: #fecdcd;
  text-align: center;
  color: #ffffff;
  font-size: 15px;
  border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/retrieve2.vue